export default __webpack_public_path__ + "static/media/companyn.f873f6ab.jpg";